const lingo =
  window.config.iso_language_code !== 'de-AT'
    ? window.config.language_code
    : window.config.iso_language_code;

export function LocalData() {
  switch (lingo) {
    case 'da':
      return {
        latestHref: '/seneste-fodboldprodukter/',
        discountedHref: '/tilbud/',
        delLink: 'https://www.unisport.dk/faq/levering-og-afhentning/',
        returnLink: 'https://www.unisport.dk/faq/retur-og-reklamation/',
        paymentLink: 'https://www.unisport.dk/faq/betaling-og-gavekort/',
        pricematchLink: 'https://www.unisport.dk/faq/generelt/prismatch/',
        supportLink: 'unisport@unisport.dk'
      };
    case 'en':
      return {
        latestHref: '/latest-football-products/',
        discountedHref: '/discounted/',
        delLink: 'https://www.unisportstore.com/faq/delivery/',
        returnLink: 'https://www.unisportstore.com/faq/return/',
        paymentLink: 'https://www.unisportstore.com/faq/payment/',
        pricematchLink: '',
        supportLink: 'support@unisportstore.com'
      };
    case 'nb':
      return {
        latestHref: '/nye-fotballprodukter/',
        discountedHref: '/tilbud/',
        delLink: 'https://www.unisportstore.no/faq/levering/',
        returnLink: 'https://www.unisportstore.no/faq/retur-og-reklamasjon/',
        paymentLink: 'https://www.unisportstore.no/faq/betaling-og-gavekort/',
        pricematchLink:
          'https://www.unisportstore.no/blog/9119-unisport-prismatch/',
        supportLink: 'support@unisportstore.no'
      };
    case 'sv':
      return {
        latestHref: '/nyaste-fotbollsprodukterna/',
        discountedHref: '/fynd/',
        delLink: 'https://www.unisportstore.se/faq/leverans/',
        returnLink: 'https://www.unisportstore.se/faq/retur-reklamation/',
        paymentLink: 'https://www.unisportstore.se/faq/betalning/',
        pricematchLink:
          'https://www.unisportstore.se/blog/9118-unisport-prisgaranti/',
        supportLink: 'support@unisportstore.se'
      };
    case 'fi':
      return {
        latestHref: '/uusimmat-jalkapallotuotteet/',
        discountedHref: '/tarjoukset/',
        delLink: 'https://www.unisportstore.fi/faq/toimitus/',
        returnLink: 'https://www.unisportstore.fi/faq/palautus-reklamaatio/',
        paymentLink: 'https://www.unisportstore.fi/faq/tilaaminen/',
        pricematchLink:
          'https://www.unisportstore.fi/blog/9121-unisport-hintatakuu/',
        supportLink: 'support@unisportstore.fi'
      };
    case 'nl':
      return {
        latestHref: '/de-nieuwste-voetbalproducten/',
        discountedHref: '/aanbiedingen/',
        delLink: 'https://www.unisportstore.nl/faq/bestellen-bezorgen/',
        returnLink: 'https://www.unisportstore.nl/faq/annuleren-retour/',
        paymentLink: 'https://www.unisportstore.nl/faq/betalen/',
        pricematchLink:
          'https://www.unisportstore.nl/blog/9117-unisports-laagste-prijs-garantie/',
        supportLink: 'support@unisportstore.nl'
      };
    case 'de':
      return {
        latestHref: '/neueste-fussballprodukte/',
        discountedHref: '/aktuelle-angebote/',
        delLink: 'https://www.unisportstore.de/faq/versand-lieferung',
        returnLink:
          'https://www.unisportstore.de/faq/ruecksendung-rueckerstattung',
        paymentLink: 'https://www.unisportstore.de/faq/zahlung-gutscheine',
        pricematchLink:
          'https://www.unisportstore.de/blog/9116-unisport-preisgarantie/',
        supportLink: 'support@unisportstore.de'
      };
    case 'de-AT':
      return {
        latestHref: '/neueste-fussballprodukte/',
        discountedHref: '/aktuelle-angebote/',
        delLink: 'https://www.unisportstore.at/faq/versand-lieferung',
        returnLink:
          'http://www.unisportstore.at/faq/ruecksendung-rueckerstattung',
        paymentLink: 'https://www.unisportstore.at/faq/zahlung-gutscheine',
        pricematchLink:
          'https://www.unisportstore.at/blog/10959-unisport-preisgarantie/',
        supportLink: 'support@unisportstore.at'
      };
    case 'fr':
      return {
        latestHref: '/nouveautes-equipements/',
        discountedHref: '/soldes-et-promotions/',
        delLink: 'https://www.unisportstore.fr/faq/livraisons',
        returnLink: 'https://www.unisportstore.fr/faq/retours',
        paymentLink: 'https://www.unisportstore.fr/faq/paiements',
        pricematchLink:
          'https://www.unisportstore.fr/blog/9111-unisport-garantit-le-meilleur-prix/',
        supportLink: 'support@unisportstore.fr'
      };
    case 'pl':
      return {
        latestHref: '/najnowsze-produkty-pilkarskie/',
        discountedHref: '/letnia-wyprzedaz/',
        delLink: 'https://www.unisport.pl/faq/dostawa/',
        returnLink: 'https://www.unisport.pl/faq/zwrot-zamowienia/',
        paymentLink: 'https://www.unisport.pl/faq/platnosc/',
        pricematchLink:
          'https://www.unisport.pl/faq/platnosc/unisport-pricematch/'
      };
    case 'it':
      return {
        latestHref: '/ultimi-prodotti-per-il-calcio/',
        discountedHref: '/saldi/',
        delLink: 'https://www.unisportstore.it/faq/consegna/',
        returnLink: 'https://www.unisportstore.it/faq/resi-e-rimborsi/',
        paymentLink: 'https://www.unisportstore.it/faq/ordine-e-pagamento/',
        pricematchLink:
          'https://www.unisportstore.it/faq/ordine-e-pagamento/allineate-con-il-loro-prezzo/'
      };
    default:
      return {
        latestHref: '/latest-football-products/',
        discountedHref: '/discounted/',
        pricematchLink: ''
      };
  }
}

const initialState = {
  isMobile: window.innerWidth < 768,
  isTablet: window.innerWidth >= 768 && window.innerWidth < 1000,
  isSmallDesktop: window.innerWidth >= 1000 && window.innerWidth < 1350,
  isBigDesktop: window.innerWidth >= 1350,
  language: lingo,
  local_data: LocalData(),
  version_2: false
};

// eslint-disable-next-line default-param-last
export default function general(state = initialState, action) {
  switch (action.type) {
    case 'SCREEN_RESIZE': {
      const newState = {
        ...state,
        isMobile: action.width < 768,
        isTablet: action.width >= 768 && action.width < 1000,
        isSmallDesktop: action.width >= 1000 && action.width < 1350,
        isBigDesktop: action.width >= 1350
      };
      return newState;
    }
    default:
      return state;
  }
}
